<template>
  <el-dialog v-dialog-drag width="860px" :title="title" :visible.sync="visible" append-to-body :close-on-click-modal="false" @closed="onclosed">
    <draggable v-if="exprGroupList.length" :list="exprGroupList" handle=".group-drag">
      <div v-for="group in exprGroupList" :key="group.id" class="group">
        <div class="group-prefix">
          <span>组间关系：</span>
          <el-select v-model="exprJoinOp" size="mini" class="textMode">
            <el-option v-for="{ cnName, id } in andOr" :key="id" :label="cnName" :value="id"></el-option>
          </el-select>
        </div>
        <div class="group-header">
          <i class="iconfont icon-drag group-drag"></i><span class="name">条件组，组内关系：</span>
          <el-select v-model="group.joinOp" size="mini" class="textMode">
            <el-option v-for="{ cnName, id } in andOr" :key="id" :label="cnName" :value="id"></el-option>
          </el-select>
          <el-button size="mini" type="text" class="el-button--danger" icon="el-icon-delete" @click="deleteItem(exprGroupList, group, 'group')"> 删除本分组 </el-button>
        </div>
        <div class="group-body">
          <table border="1">
            <tr>
              <th width="20" />
              <th width="200">关联表字段</th>
              <th width="150">操作符</th>
              <th width="300">值</th>
              <th align="left" />
            </tr>
            <draggable tag="tbody" :list="group.exprList" handle=".item-drag">
              <tr is="sqlRow" v-for="expr in group.exprList" :key="expr.id" :expr="expr">
                <template slot="prefix"><i class="iconfont icon-drag item-drag" /></template>
                <template slot="suffix">
                  <el-button size="mini" icon="el-icon-delete" type="text" class="deleteTextBtn" @click="deleteItem(group.exprList, expr, 'expr')" />
                </template>
              </tr>
            </draggable>
          </table>
        </div>
        <div class="group-footer">
          <el-button size="mini" type="text" icon="el-icon-plus" @click="addItem(group)">增加条件</el-button>
        </div>
      </div>
    </draggable>
    <div class="basic-footer">
      <el-button size="mini" plain type="primary" icon="el-icon-plus" @click="addGroup()">增加分组</el-button>
    </div>
    <template slot="footer">
      <el-button size="small" @click="close()">取消</el-button>
      <el-button type="primary" size="small" @click="submit()">确定</el-button>
    </template>
  </el-dialog>
</template>
<script>
import { asyncMixin } from "@/CommonDP/commons/asyncCom";
import sqlRow from "./row.vue";
import service from "@/CommonDP/service/metadata-service.js";
import { andOr } from "./utils";
import draggable from "vuedraggable";

export default {
  components: { sqlRow, draggable },
  mixins: [asyncMixin],
  data() {
    return {
      andOr,
      visible: false,
      exprJoinOp: "",
      exprGroupList: [],
      title: "条件编辑器",
      keyTableId: "",
      valTableId: "",
      subTableId: "",
      fieldList: [
        { label: "查询字段", id: "1", prefix: "", suffix: "", list: [] },
        { label: "数据引用", id: "2", prefix: "{", suffix: "}", list: [] },
        { label: "从表数据", id: "3", prefix: "{", suffix: "}", list: [] }
      ]
    };
  },
  computed: {
    formFields() {
      return this.getFields(0);
    },
    tableFields() {
      return this.getFields(1);
    },
    subFields() {
      return this.getFields(2);
    }
  },

  methods: {
    getFields(index = 0) {
      const { prefix, suffix, list } = this.fieldList[index];
      return list.map(({ columnName, columnDisplayName }) => ({
        id: `${prefix}${columnName}${suffix}`,
        cnName: columnDisplayName
      }));
    },
    async show(params) {
      if (!params) {
        throw new Error("参数 params 不能为空");
      }
      Object.assign(this, params);
      await this.getField();
      this.visible = true;
    },

    addGroup() {
      this.exprGroupList.push({
        id: Date.now(),
        joinOp: "and",
        exprList: []
      });
    },
    addItem(group) {
      group.exprList.push({
        id: Date.now(),
        fieldName: "",
        op: "",
        value: "",
        value2: "",
        valueSource: 1, // 1：输入值；2：表单引用值
        dataType: "", // 预留
        valueType: "" // 预留
      });
    },
    async deleteItem(list = [], item, itemType) {
      await this.$confirm("确定删除" + (itemType === "group" ? "本分组？注意：分组下的所有条件将被移除" : "本行？"), "警告", { type: "warning" });
      const index = list.indexOf(item);
      if (index >= 0) {
        list.splice(index, 1);
      }
    },
    async getField() {
      const { keyTableId, valTableId, subTableId } = this;
      const tableIds = [keyTableId, valTableId];
      if (subTableId) tableIds.push(subTableId);
      const list = await Promise.all(tableIds.map((id) => this.getList(id)));
      list.forEach((item, index) => {
        this.fieldList[index].list = item;
      });
    },
    async open() {
      await this.getField();
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    submit() {
      const { exprGroupList, exprJoinOp } = this;
      this.$emit("resolve", { exprGroupList, exprJoinOp });
      this.visible = false;
    },
    onclosed() {
      this.$emit("reject");
    },
    async getList(tableId) {
      if (!tableId) return;
      const { data } = await service.columnList(tableId);
      return data;
    }
  }
};
</script>
<style lang="scss" scoped src="./index.scss"></style>
